import React from 'react';
import { Space, Tag, Tooltip, Typography } from 'antd';
import TotalOrderItem from '../components/TotalOrderItem';
import { useTranslation } from 'react-i18next';
import { sumBy } from 'lodash';
import { formatMoney } from 'utils/formattedString';
import { DynamicObjectType } from 'types/commons';
import { getDataDetail } from 'utils/tools';

const PaymentInformation = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Space size={10} className="w-full" direction="vertical">
      <TotalOrderItem
        title={t('orderDetail.totalProducts')}
        value={sumBy(data?.items, 'quantity')}
      />
      <TotalOrderItem
        title={t('orderDetail.totalPrice')}
        value={formatMoney(data?.total)}
        boldTitle
        boldValue
      />
      <TotalOrderItem title={t('orderDetail.directDiscount')} />
      <Space size={5} wrap>
        {data?.promotionInfos
          ?.filter((p: DynamicObjectType) => p?.promotionType !== 'order')
          ?.map((promotion) => (
            <Tooltip
              title={getDataDetail(promotion, 'detail', 'name', null)?.name}
            >
              <Tag
                key={promotion?.id}
                className="bg-[--bg-light] border border-[--primary] p-1 rounded-md"
              >
                <Typography.Paragraph
                  ellipsis={{ rows: 1 }}
                  style={{
                    wordWrap: 'break-word',
                    wordBreak: 'break-word',
                    marginBottom: 0,
                  }}
                  className="max-w-[150px] text-[--primary] text-xs"
                >
                  {getDataDetail(promotion, 'detail', 'name', null)?.name}
                </Typography.Paragraph>
              </Tag>
            </Tooltip>
          ))}
      </Space>
    </Space>
  );
};

export default PaymentInformation;
